/* kxo-sticky-atc.js */
(() => {
  const STICKY_ID = "kxo-sticky-atc";

  const TEST_PRODUCT_IDS = [
    "10722628174161",
    "10748509126993",
    "10748526887249",
    "10807085269329",
    "10894881653073",
    "10927727083857",
  ];

  const selectors = {
    kxoRoot: '[data-kxo-root][data-kxo-mode="form"]',
    form: 'form[action^="/cart/add"]',

    // real ATC inside the form
    realSubmitBtn:
      'button[id^="ProductSubmitButton-"], button[name="add"][type="submit"], button[type="submit"], .product-form__submit',

    // footer
    footer:
      ".shopify-section-group-footer-group, .shopify-section.shopify-section-group-footer-group, footer, #shopify-section-footer, .shopify-section-footer, .footer",

    // athlete discount
    discount: "#athlete-discount",

    // checks list
    checksList: "ul.icon-with-text.icon-with-text--horizontal",

    // test product
    testRoot: ".kqv[data-product-id]",
    atcLabel: ".atc-label",
  };

  const I18N = {
    en: {
      sub: "SUBSCRIBE NOW - ",
      one: "BUY NOW - ",
      upgrade: "Choose subscription and get 15% off + a free bottle",
    },
    fr: {
      sub: "S'ABONNER - ",
      one: "ACHETER - ",
      upgrade: "Choisissez l’abonnement et obtenez -15 % + une gourde offerte",
    },
  };

  const qs = (r, s) => (r ? r.querySelector(s) : null);
  const qsa = (r, s) => (r ? Array.from(r.querySelectorAll(s)) : []);

  const getLang = () => {
    const shopifyLocale = window.Shopify?.locale ? String(window.Shopify.locale) : "";
    const htmlLang = document.documentElement.getAttribute("lang") || "";
    const raw = (shopifyLocale || htmlLang || "").toLowerCase();
    if (raw.startsWith("fr")) return "fr";
    return "en";
  };

  const t = () => I18N[getLang()] || I18N.en;

  function ensureSticky() {
    let el = document.getElementById(STICKY_ID);
    if (el) return el;

    el = document.createElement("div");
    el.id = STICKY_ID;
    el.className = "kxo-sticky-atc";
    el.innerHTML = `
      <div class="kxo-sticky-atc__inner">
        <div class="kxo-sticky-atc__discount" data-kxo-sticky-discount hidden></div>

        <button class="kxo-sticky-atc__btn button" type="button" data-kxo-sticky-btn></button>

        <div class="kxo-sticky-atc__below">
          <div class="kxo-sticky-atc__checks" data-kxo-sticky-checks hidden></div>
          <div class="kxo-sticky-atc__upgrade" data-kxo-sticky-upgrade hidden>
            <a href="#" data-kxo-sticky-upgrade-link></a>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(el);
    return el;
  }

  function getFooterEl() {
    return document.querySelector(selectors.footer);
  }

  function getRealBtn(form) {
    return form ? form.querySelector(selectors.realSubmitBtn) : null;
  }

  function isElementVisiblyRendered(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.display === "none") return false;
    if (style.visibility === "hidden") return false;
    if (parseFloat(style.opacity || "1") === 0) return false;
    if (el.getClientRects().length === 0) return false;
    return true;
  }

  function setupVisibility(realBtn, sticky) {
    let mainVisible = true;
    let footerVisible = false;

    const footerEl = getFooterEl();

    const compute = () => {
      const show = !mainVisible && !footerVisible;
      sticky.classList.toggle("is-visible", show);
      document.body.classList.toggle("kxo-sticky-atc-on", show);
    };

    const rectCheck = () => {
      const vh = window.innerHeight || 0;

      if (realBtn) {
        const r = realBtn.getBoundingClientRect();
        const inView = r.bottom > 0 && r.top < vh;
        const meaningful = r.top < vh * 0.85 && r.bottom > vh * 0.15;
        mainVisible = meaningful || inView;
      } else {
        mainVisible = true;
      }

      if (footerEl) {
        const f = footerEl.getBoundingClientRect();
        footerVisible = f.top < vh && f.bottom > 0;
      } else {
        footerVisible = false;
      }

      compute();
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;

      ticking = true;

      requestAnimationFrame(() => {
        ticking = false;
        rectCheck();
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    let ioBtn = null;
    let ioFooter = null;

    try {
      ioBtn = new IntersectionObserver(
        (entries) => {
          const isInt = !!entries[0]?.isIntersecting;
          if (typeof isInt === "boolean") mainVisible = isInt;
          compute();
        },
        { threshold: 0.01, rootMargin: "0px 0px -25% 0px" }
      );

      ioBtn.observe(realBtn);
    } catch (_) {}

    if (footerEl) {
      try {
        ioFooter = new IntersectionObserver(
          (entries) => {
            const isInt = !!entries[0]?.isIntersecting;
            if (typeof isInt === "boolean") footerVisible = isInt;
            compute();
          },
          { threshold: 0.01 }
        );

        ioFooter.observe(footerEl);
      } catch (_) {}
    }

    rectCheck();

    return () => {
      try {
        ioBtn && ioBtn.disconnect();
      } catch (_) {}

      try {
        ioFooter && ioFooter.disconnect();
      } catch (_) {}

      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }

  /* ======================
     existing KXO logic
  ====================== */

  function getMainKxoRoot() {
    return document.querySelector(selectors.kxoRoot);
  }

  function getMainForm(kxoRoot) {
    if (!kxoRoot) return document.querySelector(selectors.form);

    const sectionId = kxoRoot.getAttribute("data-kxo-id") || "";
    const byId = sectionId ? document.getElementById(`product-form-${sectionId}`) : null;

    if (byId) return byId;

    return kxoRoot.closest(selectors.form) || document.querySelector(selectors.form);
  }

  function getMode(kxoRoot) {
    const id = kxoRoot.getAttribute("data-kxo-id");
    const checked = id ? kxoRoot.querySelector(`input[name="kxo-mode-${id}"]:checked`) : null;

    return checked ? checked.value : "subscription";
  }

  function getPriceText(kxoRoot, mode) {
    const el =
      mode === "subscription"
        ? kxoRoot.querySelector('[data-kxo-price="subscription"]')
        : kxoRoot.querySelector('[data-kxo-price="onetime"]');

    return (el?.textContent || "").trim();
  }

  function setSubscriptionMode(kxoRoot) {
    const id = kxoRoot.getAttribute("data-kxo-id");
    const radio = id ? kxoRoot.querySelector(`input[name="kxo-mode-${id}"][value="subscription"]`) : null;

    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function cloneChecksNear(form) {
    const scope =
      form?.closest(".product__info-container") ||
      form?.closest(".product__info-wrapper") ||
      form?.closest(".shopify-section") ||
      document;

    const list = qs(scope, selectors.checksList);
    if (!list) return null;

    const clone = list.cloneNode(true);
    qsa(clone, "[id]").forEach((n) => n.removeAttribute("id"));

    return clone;
  }

  function readAthleteDiscountIfVisible(form) {
    const scope =
      form?.closest(".product__info-container") ||
      form?.closest(".product__info-wrapper") ||
      form?.closest(".shopify-section") ||
      document;

    const node = qs(scope, selectors.discount) || document.querySelector(selectors.discount);

    if (!node) return "";
    if (!isElementVisiblyRendered(node)) return "";

    return (node.textContent || "").trim();
  }

  function syncKxoUI(kxoRoot, form, realBtn) {
    const sticky = ensureSticky();
    const btn = qs(sticky, "[data-kxo-sticky-btn]");
    const discountEl = qs(sticky, "[data-kxo-sticky-discount]");
    const checksWrap = qs(sticky, "[data-kxo-sticky-checks]");
    const upgradeWrap = qs(sticky, "[data-kxo-sticky-upgrade]");
    const upgradeLink = qs(sticky, "[data-kxo-sticky-upgrade-link]");

    const copy = t();
    const mode = getMode(kxoRoot);
    const price = getPriceText(kxoRoot, mode);

    const discountText = readAthleteDiscountIfVisible(form);

    if (discountText) {
      discountEl.hidden = false;
      discountEl.textContent = discountText;
    } else {
      discountEl.hidden = true;
      discountEl.textContent = "";
    }

    btn.textContent =
      mode === "subscription"
        ? `${copy.sub}${price}`.trim()
        : `${copy.one}${price}`.trim();

    btn.onclick = (e) => {
      e.preventDefault();
      if (!realBtn) return;
      realBtn.click();
    };

    if (mode === "subscription") {
      upgradeWrap.hidden = true;
      upgradeLink.textContent = "";
      upgradeLink.onclick = null;

      checksWrap.hidden = false;
      checksWrap.innerHTML = "";

      const clone = cloneChecksNear(form);
      if (clone) checksWrap.appendChild(clone);
    } else {
      checksWrap.hidden = true;
      checksWrap.innerHTML = "";

      upgradeWrap.hidden = false;
      upgradeLink.textContent = copy.upgrade;

      upgradeLink.onclick = (e) => {
        e.preventDefault();
        setSubscriptionMode(kxoRoot);
      };
    }
  }

  function bootKxoMode() {
    const sticky = ensureSticky();

    const kxoRoot = getMainKxoRoot();
    if (!kxoRoot) return false;

    const form = getMainForm(kxoRoot);
    if (!form) return false;

    const realBtn = getRealBtn(form);
    if (!realBtn) return false;

    syncKxoUI(kxoRoot, form, realBtn);

    const cleanupVis = setupVisibility(realBtn, sticky);

    const id = kxoRoot.getAttribute("data-kxo-id");
    const radios = id ? qsa(kxoRoot, `input[name="kxo-mode-${id}"]`) : [];

    const onRadio = () => syncKxoUI(kxoRoot, form, realBtn);

    radios.forEach((r) => r.addEventListener("change", onRadio));

    const mo = new MutationObserver(() => syncKxoUI(kxoRoot, form, realBtn));

    mo.observe(kxoRoot, {
      subtree: true,
      childList: true,
      characterData: true,
    });

    const discountNode = document.querySelector(selectors.discount);

    const moDiscount = discountNode
      ? new MutationObserver(() => syncKxoUI(kxoRoot, form, realBtn))
      : null;

    if (moDiscount && discountNode) {
      moDiscount.observe(discountNode, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
      });
    }

    window.addEventListener("pagehide", () => {
      try {
        mo.disconnect();
      } catch (_) {}

      try {
        moDiscount && moDiscount.disconnect();
      } catch (_) {}

      try {
        cleanupVis && cleanupVis();
      } catch (_) {}

      radios.forEach((r) => r.removeEventListener("change", onRadio));
    });

    return true;
  }

  /* ======================
     test product logic
  ====================== */

  function getTestRoot() {
    return qsa(document, selectors.testRoot).find((root) =>
      TEST_PRODUCT_IDS.includes(String(root.dataset.productId))
    );
  }

  function getTestForm(testRoot) {
    const formId = testRoot?.getAttribute("data-product-form-id") || "";

    if (formId) {
      const byId = document.getElementById(formId);
      if (byId) return byId;
    }

    return testRoot?.closest(selectors.form) || document.querySelector(selectors.form);
  }

  function getTestButtonLabel(form) {
    const labelEl = form ? form.querySelector(selectors.atcLabel) : null;
    if (!labelEl) return "";

    const clone = labelEl.cloneNode(true);

    // Remove compare price / crossed price from sticky ATC label
    qsa(
      clone,
      ".qty-test-atc__compare, .price__compare, .price-item--regular, [data-compare-price], s"
    ).forEach((el) => el.remove());

    return (clone.textContent || "").replace(/\s+/g, " ").trim();
  }

  function syncTestUI(testRoot, form, realBtn) {
    const sticky = ensureSticky();
    const btn = qs(sticky, "[data-kxo-sticky-btn]");
    const discountEl = qs(sticky, "[data-kxo-sticky-discount]");
    const checksWrap = qs(sticky, "[data-kxo-sticky-checks]");
    const upgradeWrap = qs(sticky, "[data-kxo-sticky-upgrade]");

    const label = getTestButtonLabel(form);

    discountEl.hidden = true;
    discountEl.textContent = "";

    checksWrap.hidden = true;
    checksWrap.innerHTML = "";

    upgradeWrap.hidden = true;

    btn.textContent = label || "";

    btn.onclick = (e) => {
      e.preventDefault();
      if (!realBtn || realBtn.disabled) return;
      realBtn.click();
    };
  }

  function bootTestMode() {
    const sticky = ensureSticky();

    const testRoot = getTestRoot();
    if (!testRoot) return false;

    const form = getTestForm(testRoot);
    if (!form) return false;

    const realBtn = getRealBtn(form);
    if (!realBtn) return false;

    syncTestUI(testRoot, form, realBtn);

    const cleanupVis = setupVisibility(realBtn, sticky);

    const moForm = new MutationObserver(() => syncTestUI(testRoot, form, realBtn));

    moForm.observe(form, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
    });

    const moTestRoot = new MutationObserver(() => syncTestUI(testRoot, form, realBtn));

    moTestRoot.observe(testRoot, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
    });

    window.addEventListener("pagehide", () => {
      try {
        moForm.disconnect();
      } catch (_) {}

      try {
        moTestRoot.disconnect();
      } catch (_) {}

      try {
        cleanupVis && cleanupVis();
      } catch (_) {}
    });

    return true;
  }

  /* ======================
     init
  ====================== */

  function boot() {
    if (bootKxoMode()) return true;
    if (bootTestMode()) return true;

    return false;
  }

  function initWithRetry() {
    const start = Date.now();
    const timeout = 14000;

    const tick = () => {
      if (boot()) return;
      if (Date.now() - start > timeout) return;

      requestAnimationFrame(tick);
    };

    tick();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWithRetry);
  } else {
    initWithRetry();
  }

  document.addEventListener("shopify:section:load", initWithRetry);
  window.addEventListener("pageshow", initWithRetry);
})();